<template>
  <div class="list-content-right">
    <img
      src="https://resource.rcclchina.com.cn/logo/PC/logoCruiseSearchAdvantage.jpg"
      style="max-width: 258px"
    />
    <div class="list-month-top-con">
      <template v-if="cruises.length > 0">
        <div class="top-header">
          每周畅销排行榜
          <span class="top-header-text">TOP 5</span>
        </div>
        <div class="top-list">
          <div v-for="(cruise, i) in cruises" :key="'cruise_' + i">
            <div
              class="top-list-item"
              @click="goToCruiseDetail(cruise, i)"
              @mouseenter="targetIndex = i"
            >
              <div class="top-list-item-normal" v-show="targetIndex != i">
                <img class="top-item-img" :src="cruise.pcImage" />
                <div>
                  <div class="top-item-top-num">NO.{{ i + 1 }}</div>
                  <div class="top-item-title-con">
                    <div class="top-item-title">{{ cruise.cruiseName }}</div>
                  </div>
                  <div class="top-item-time" style="line-height: 16px">
                    {{ cruise.sailDateBegin + " - " + cruise.sailDateEnd }}
                  </div>
                </div>
              </div>
              <div class="top-list-item-active" v-show="targetIndex == i">
                <div class="top-item-img-con">
                  <div class="top-item-img-box">
                    <img class="top-item-img1" :src="cruise.pcImage" />
                    <img class="top-item-img-one" :src="getTopImage(i + 1)" />
                  </div>
                </div>
                <div class="top-item-title-con">
                  <div class="top-item-title">{{ cruise.cruiseName }}</div>
                </div>
                <div class="top-item-time">
                  {{ cruise.sailDateBegin + " - " + cruise.sailDateEnd }}
                </div>
              </div>
            </div>
            <div class="line" v-if="i < cruises.length - 1"></div>
          </div>
        </div>
      </template>
      <div class="list-month-bottom" v-if="banners && banners.length > 0">
        <a
          :href="banner.link"
          target="_blank"
          class="list-month-bottom-content"
          v-for="(banner, i) in banners"
          :key="'banner_' + i"
        >
          <img :src="banner.imageUrl" style="width: 258px" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {gioAdsTracking, gioTracking} from "@/utilities/tools";
export default {
  name: "CruiseSearchRight",
  data() {
    return {
      targetIndex: 0,
    };
  },
  methods: {
    goToCruiseDetail(cruise, index) {
			let url = `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?shipCode=${cruise.shipCode}&sailDate=${cruise.sailDate}`
      gioTracking('track', 'evt_ButtonClicked',{
        'btnType': `CruiseSearchTOP5`
      })
			gioAdsTracking({
				'adsType': 'tl',
				'topList': index + 1,
				'desUrl': url
			})
      window.open(url);
      // this.$router.push({
      //     name: "CruiseDetail",
      //     query: {
      //         shipCode: cruise.shipCode,
      //         sailDate: cruise.sailDate
      //     }
      // })
    },
    getTopImage(index) {
      let num = index + "";
      if (num.length == 1) {
        num = "0" + num;
      }
      return `https://resource.rcclchina.com.cn/cruiseSearch/topCruise/top${num}.png`;
    },
  },
  computed: {
    cruiseSearchPage() {
      return this.$store.state.cruise.cruiseSearchPage || {};
    },
    cruises() {
      return this.cruiseSearchPage.cruiseTopSells || [];
    },
    banners() {
      return this.cruiseSearchPage.cruiseSearchBanners || [];
    },
  },
};
</script>

<style lang="less" scoped>
.list-content-right {
  margin-left: 20px;
  float: right;
  width: 258px;
  img {
    width: 100%;
  }
  .top-header {
    font-size: 16px;
    color: #282b2c;
    margin-top: 10px;
    margin-bottom: 15px;
    .top-header-text {
      font-size: 32px;
      color: #ffa70d;
      margin-left: 6px;
    }
  }
  .top-list {
    width: 258px;
    background-color: #fff;
    padding: 10px 16px 8px;
    .top-list-item {
      padding: 10px 0;
      cursor: pointer;
      .top-item-img {
        width: 90px;
        height: 90px;
        margin-right: 12px;
        float: left;
      }
      .top-item-top-num {
        font-size: 16px;
        font-weight: 600;
        color: #ffa70d;
        margin-bottom: 5px;
      }
      .top-item-title-con {
        position: relative;
      }
      .top-item-time {
        font-size: 12px;
        line-height: 20px;
        color: #747d80;
      }
      .top-item-img-con {
        width: 120px;
        margin: 0 auto;
        margin-bottom: 16px;
        .top-item-img-box {
          position: relative;
          .top-item-img1 {
            width: 120px;
            height: 120px;
            background-color: #f4f5f9;
            box-shadow: 6px 7px 10px 0px rgba(27, 26, 24, 0.21);
          }
          .top-item-img-one {
            position: absolute;
            top: 0;
            right: -23px;
            width: 86px;
          }
        }
      }
      .top-item-title {
        font-size: 14px;
        line-height: 20px;
        color: #282b2c;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #e5e9eb;
    }
  }
  .list-month-bottom {
    // background-color: #fff;
    margin-top: 10px;
    .list-month-bottom-content {
      margin-bottom: 10px;
      display: block;
      img {
        display: block;
      }
    }
  }
}
</style>
